"use strict";module.exports=function(value){return null===value||"function"!=typeof value&&"object"!=typeof value};